export default __webpack_public_path__ + "static/4ab2748396745897935a57aef426ccd7.svg";